import React, { useState } from "react";

const DateModal = ({ isOpen, onClose, fromDate, setFromDate, toDate, setToDate }) => {
    const [localFromDate, setLocalFromDate] = useState(fromDate);
    const [localToDate, setLocalToDate] = useState(toDate);

    if (!isOpen) return null;

    const handleSubmit = () => {
        console.log("From Date:", fromDate);
        console.log("To Date:", toDate);
        setFromDate(localFromDate);
        setToDate(localToDate)
        onClose(); // Close modal after submission
    };

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-96 p-6">
                <h2 className="text-xl text-primary mb-4">Select Date Range</h2>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm mb-2 text-start" htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        type="date"
                        id="fromDate"
                        value={localFromDate}
                        onChange={(e) => setLocalFromDate(e.target.value)}
                        className="w-full px-3 input-field"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm mb-2 text-start" htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        type="date"
                        id="toDate"
                        value={localToDate}
                        onChange={(e) => setLocalToDate(e.target.value)}
                        className="w-full px-3 input-field"
                    />
                </div>
                <div className="flex justify-between">
                    <button
                        className="bg-gray-500 text-white px-4 py-2 rounded-md mr-2 hover:bg-gray-600"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DateModal;
